import { CACHE_TAG_ACCOUNT_PAYMENT_DETAILS } from 'api/cacheTagTypes'
import Constants from 'Constants'
import api from '../index'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getPaymentsData: builder.query({
      query: ({ businessId, accountId }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/tenants/${businessId}/accounts/${accountId}/payment`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_ACCOUNT_PAYMENT_DETAILS],
    }),
    updateAutopay: builder.mutation({
      query: ({ businessId, accountId, payload }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/tenants/${businessId}/accounts/${accountId}/payment/autopay/add`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const { useLazyGetPaymentsDataQuery, useUpdateAutopayMutation } = extendedApi
